<template>
 <div class="footer">
    <div class="container d-flex">
        <div class="left">

            <img height="25" width="200" src="../../images/placeholder.png" alt="">
            <div class="social-media">
                <a href="#">
                    <i class="fa fa-linkedin"></i>
                </a>
                <a href="#">
                    <i class="fa fa-twitter"></i>
                </a>
                <a href="#">
                    <i class="fa fa-youtube"></i>
                </a>
            </div>
            <div class="footer-text">
                All right reserved 2020 &copy;
                <i class="la la-check-circle-o"></i>
            </div>
        </div>
        <div class="right">
            <div class="footer-links">
                <a href="mailto:info@startupfalcon.com">
                    Contact Us
                </a>
                <router-link :to="{'name': 'privacy'}">
                    Privacy Policy
                </router-link>
                <router-link :to="{'name': 'pricing'}">
                    FAQs
                </router-link>
                <router-link :to="{'name': 'tos'}">
                    Terms of Use
                </router-link>
            </div>
        </div>
    </div>
</div>

</template>

<script>
    export default {
        data(){
          return {

          }
        },
        props: {
        },
    };
</script>

<style lang="scss">
.footer {
  padding: 15px 10px;
  background-color: #000;
  display: flex;
  min-height: 140px;
  margin-top: 60px;

  .left {
    flex: 1.6;
  }

  .right {
    flex: 1;
  }

  .footer-text {
    margin-top: 15px;
  }

  .footer-links {
    text-align: right;
    margin-top: 45px;

    a {
      border-right: 1px solid #fff;
      padding: 0 10px;
      color: #fff;

      &:last-child {
        border-right: none;
      }
    }
  }
}
</style>
